module.exports = __webpack_public_path__ + "static/Sameeksha.00c87d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Sameeksha.jpg
// module id = 1322
// module chunks = 137408898365125